import { render } from "./PantryIngredientCameraEmptyView.vue?vue&type=template&id=6dbd6369&ts=true"
import script from "./PantryIngredientCameraEmptyView.vue?vue&type=script&lang=ts"
export * from "./PantryIngredientCameraEmptyView.vue?vue&type=script&lang=ts"

import "./PantryIngredientCameraEmptyView.vue?vue&type=style&index=0&id=6dbd6369&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__